import { createFastContext } from '@rst/libs-ts'
import React, { ReactNode } from 'react'

type Handler =
	| null
	| ((arg: { to?: string; href?: string }) => { to?: string; href?: string })

const { Provider, useCtx } = createFastContext<{
	handler: Handler
}>({ handler: null })

const LinkHandlerProvider = ({
	handler,
	children,
}: {
	handler: Handler
	children: ReactNode
}) => {
	return <Provider value={{ handler }}>{children}</Provider>
}

export { useCtx as useLinkHandler, LinkHandlerProvider }
